import Product from '@/ts/Product'

import List from './includes/List'
import AllSlotsButton from './includes/ShowAllSlotsButton'

function FansiClass({ product }: FansiClassProps) {
  if (product.time_slots.length <= 0) {
    return <p className="text-lg text-black/60">Brak dostępnych terminów</p>
  }

  return (
    <div className="flex flex-col items-center w-full space-y-10">
      <List product={product} />
      {product.time_slots.length > 2 && <AllSlotsButton product={product} />}
    </div>
  )
}

interface FansiClassProps {
  product: Product
}

export default FansiClass
